var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "meta-referrals" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "referrals" }, [
        _vm.contact.metaReferrals.length === 0
          ? _c("div", { staticClass: "no-referrals" }, [
              _c("i", { staticClass: "fas fa-info-circle" }),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("message.noMetaReferrals")))]),
            ])
          : _c(
              "div",
              _vm._l(_vm.contact.metaReferrals, function (ad) {
                return _c(
                  "div",
                  { key: ad._id, staticClass: "referrals-item" },
                  [
                    _c("div", { staticClass: "headline" }, [
                      ad.sourceLink
                        ? _c(
                            "a",
                            {
                              staticClass: "title",
                              attrs: { href: ad.sourceLink, target: "_blank" },
                            },
                            [_vm._v(_vm._s(ad.headline || "Meta Reklam"))]
                          )
                        : _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(ad.headline || "Meta Reklam")),
                          ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "time" }, [
                        _vm._v(_vm._s(_vm.$moment(ad.createdAt).fromNow())),
                      ]),
                    ]),
                    _vm._v(" "),
                    ad.headline || ad.body
                      ? _c("div", { staticClass: "description" }, [
                          _vm._v(_vm._s(ad.body || ad.headline)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    ad.adInfo
                      ? _c("div", { staticClass: "referral-info-wrapper" }, [
                          _c("div", { staticClass: "referral-info" }, [
                            _c("div", { staticClass: "referral-detail" }, [
                              _c("div", { staticClass: "referral-label" }, [
                                _vm._v(_vm._s(_vm.$t("auto.ad"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "referral-value",
                                  attrs: { title: ad.adInfo.name || "-" },
                                },
                                [_vm._v(_vm._s(ad.adInfo.name || "-"))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "referral-detail" }, [
                              _c("div", { staticClass: "referral-label" }, [
                                _vm._v(_vm._s(_vm.$t("auto.adSet"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "referral-value",
                                  attrs: { title: _vm.getAdSetName(ad) },
                                },
                                [_vm._v(_vm._s(_vm.getAdSetName(ad)))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "referral-detail" }, [
                              _c("div", { staticClass: "referral-label" }, [
                                _vm._v(_vm._s(_vm.$t("auto.campaign"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "referral-value",
                                  attrs: { title: _vm.getCampaignName(ad) },
                                },
                                [_vm._v(_vm._s(_vm.getCampaignName(ad)))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "referral-detail" }, [
                              _c("div", { staticClass: "referral-label" }, [
                                _vm._v(_vm._s(_vm.$t("auto.status"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "referral-value status",
                                  class: _vm.getStatusClass(ad),
                                  attrs: { title: _vm.getStatus(ad) },
                                },
                                [_vm._v(_vm._s(_vm.getStatus(ad)))]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    ad.sourceLink
                      ? _c("div", { staticClass: "referral-link" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: ad.sourceLink, target: "_blank" },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-external-link-alt",
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("auto.viewAd")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }